import { render, staticRenderFns } from "./SuggestAPoster.vue?vue&type=template&id=5d8682f7"
import script from "./SuggestAPoster.vue?vue&type=script&lang=js"
export * from "./SuggestAPoster.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports